// The three live graph refs, in the shape the search walker wants.
//
// One reader, because there are now three consumers — Ctrl+F (GraphSearchBox),
// the add-node palette's "in this graph" section, and anything that comes next —
// and they must all be looking at the SAME thing. These are module singletons
// the editors mutate in place (CLAUDE.md: not React state, the render loop reads
// them), so there is nothing to subscribe to: call this at the moment you need
// an answer and it is current by construction.
//
// Deliberately reads the LIVE refs and never the saved blueprint. A search that
// could not find the node you added thirty seconds ago is not a search.

import { graphState } from './graphState'
import { faceGraphState } from './faceGraphState'
import { eventGraphState } from './eventGraphState'

/** Which walker key an editor SURFACE name maps to ('events' -> 'event'). */
export const SURFACE_TO_GRAPH = { body: 'body', face: 'face', events: 'event', event: 'event' }

/** Snapshot the three live refs. */
export function readGraphs() {
  return {
    body: { nodes: graphState.nodes ?? [] },
    face: { nodes: faceGraphState.nodes ?? [] },
    event: { nodes: eventGraphState.nodes ?? [], functions: eventGraphState.functions ?? {} },
  }
}
